<div class="image" [ngStyle]="{'background-image': 'url(' + clientLogo + ')'}"></div>
